import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNrday75 } from './pages'

type TIdToPageMapWoofzNrday75 = Record<PageIdWoofzNrday75, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NRDAY_75: TIdToPageMapWoofzNrday75 = {
  [PageId.SUBSCRIPTIONS_NRDAY_75_N]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/subscriptions/SubscriptionNrday75'
      ).then((m) => ({
        default: m.SubscriptionsNrday75,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/subscriptions/SubscriptionNrday75'
      ),
  },
  [PageId.CHAT_UPSELL_NRDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NRDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/upsell/Upsell'
      ).then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzNrday75.DOWNLOAD_NRDAY_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_nrday/woofz_nrday_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNrday75.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
